import React from 'react';
import * as PropTypes from 'prop-types';
import Loading from 'react-loading';
import style from './loader.scss';

export default class Loader extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this.props.fetchData().then(data => {
      setTimeout(() => {
        this.setState({
          loading: false,
        });
      }, 200);
      return data;
    });
  }

  render() {
    const { children, loadingText = 'Loading' } = this.props;
    return (
      <div style={{ height: '100%' }}>
        {this.state.loading ? (
          <div className={style.container}>
            <Loading
              height={40}
              width={40}
              type="spin"
              delay={0}
              color="#399998"
              className="center"
            />
            <div className={style.loadingText}>{loadingText}</div>
          </div>
        ) : (
          React.cloneElement(children, { key: 1 })
        )}
      </div>
    );
  }
}

Loader.propTypes = {
  children: PropTypes.element.isRequired,
  loadingText: PropTypes.string,
  fetchData: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/loader/index.js